import { CheckCircle } from "lucide-react"
import { CollapsibleSection } from "./CollapsibleSection"

export default function QuickStartGuide() {
  return (
    <CollapsibleSection
      title="Quick Start Guide"
      className="mb-6 shadow-sm border-slate-200/50"
      mobileBreakpoint={768}
      defaultExpanded={true}
    >
      <div className="py-8 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Create your first territory map in minutes with these simple steps
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 relative">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-lg">
                1
              </div>
              <h3 className="text-xl font-semibold mb-4 mt-2">Add Your Team</h3>
              <p className="text-gray-600 mb-4">
                Enter the names of your team members or territory owners in the data table. Each person will be assigned
                a unique color.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Click "Add Row" or upload a CSV file with your team data</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Customize colors to match your brand if needed</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 relative">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-lg">
                2
              </div>
              <h3 className="text-xl font-semibold mb-4 mt-2">Assign Territories</h3>
              <p className="text-gray-600 mb-4">
                Click on states or countries on the map to assign them to team members, or enter territory codes
                directly in the table.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Select a team member, then click regions on the map</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Use the search function to find specific regions</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 relative">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-lg">
                3
              </div>
              <h3 className="text-xl font-semibold mb-4 mt-2">Export & Share</h3>
              <p className="text-gray-600 mb-4">
                Once your map is complete, export it as an image or save it to access later. Share with your team
                instantly.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Download as PNG or PDF for presentations</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span>Save your map to access it later or make updates</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}
